@if (statement) {
  <div>
    {{ statement.surveyFieldName }}
    @if (statement.statement.eq) {
      <label>= {{ statement.statement.eq }}</label>
    }
    @if (statement.statement.gt !== undefined) {
      <label>
        > {{ statement.statement.gt }}</label
        >
      }
      @if (statement.statement.gte !== undefined) {
        <label>
          >= {{ statement.statement.gte }}</label
          >
        }
        @if (statement.statement.lt !== undefined) {
          <label>
            < {{ statement.statement.lt }}</label
            >
          }
          @if (statement.statement.lte !== undefined) {
            <label>
              <= {{ statement.statement.lte }}</label
              >
            }
            @if (statement.statement.ne !== undefined) {
              <label>
                ≠ {{ statement.statement.ne }}</label
                >
              }
              @if (statement.statement.in !== undefined) {
                <label
                  i18n="includes@@includes">
     includes {{ statement.statement.in }}</label
                  >
                }
                @if (statement.statement.notIn !== undefined) {
                  <label
                    i18n="not includes@@not_includes">
    not includes {{ statement.statement.notIn }}</label
                    >
                  }
                  <button mat-button (click)="openChangeStatementDialog()" i18n="change statement@@change_statement">
    Change Statement
  </button>
                </div>
              }
